import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import authService from '../../services/auth';
import profilesService from '../../services/profiles';

import BackdropLoading from '../commons/BackdropLoading';
import EditControllers from '../commons/EditControllers';
import Form from '../commons/Form';
import FormFields from '../commons/FormFields';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { RenewIcon } from '../commons/Icons';
import { IconButton } from '@mui/material';
import SetProfileOptionsBilling from '../commons/SetProfileOptionsBilling';

class EditProfileBilling extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      loading: false,
      error: false,
      data: {
        billing: {
          billing_payment_delay: profilesService.BILLING_PAYMENT_DELAY_30,
        }
      },
    }
  }

  componentDidMount () {
    this._isMounted = true;
    const { id_profile } = this.props;
    if (id_profile) {
      this.load();
    } else {
      console.warn("id_profile manquant - EditProfileBilling ne sert qu'à modifier un profil existant");
    }
  }

  componentDidUpdate(prevProps) {
    const reload = JSON.stringify(this.props.id_profile) !== JSON.stringify(prevProps.id_profile);
    if (reload) {
      this.load();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  load () {
    const { id_profile } = this.props;
    if (id_profile) {
      this._isMounted && this.setState({ loading: true, error: false });
      profilesService.getOptions(id_profile).then(([options]) => {
        const billing = options && options.billing ? options.billing : null;
        if (billing) {
          this._isMounted && this.setState({data: {...this.state.data, ...{billing}}});
        }
      }).catch((e) => {
        this.props.onError(e);
        this._isMounted && this.setState({ error: true });
      }).finally(() => {
        this._isMounted && this.setState({ loading: false });
      });
    }
  }

  validate () {
    return true;
  }

  save (e) {
    const { id_profile } = this.props;
    const { data } = this.state;
    e.preventDefault();
    if (!this.validate()) {
      return;
    }
    const parsed_data = {
      options: {
        billing: data.billing,
      },
    }
    this._isMounted && this.setState({loading: true})
    profilesService.update(id_profile, parsed_data).then(([id, notices]) => {
      notices && notices.length > 0 && this.props.onError(notices);
      return profilesService.get(id);
    }).then(([profile]) => {
      this.props.onSaved(profile);

      // Mise à jour du profil si c'est celui qui est authentifié
      return authService.maybeRefreshToken(profile.ID);
    }).catch((error) => {
      console.error('error : ', error);
      this.props.onError(error);
    }).finally(() => {
      this._isMounted && this.setState({loading: false})
    });
    return false;
  }

  render () {
    const { classes } = this.props;
    const { loading, error } = this.state;

    if (error) {
      return (
        <Box className={classes.container}>
          <Typography variant="h4">Erreur de chargement</Typography>
          <IconButton onClick={() => this.load()} size="large">
            <RenewIcon />
          </IconButton>
        </Box>
      );
    }

    return (
      <Box className={classes.container}>

        <BackdropLoading open={loading} />

        <Form onSubmit={ (e) => this.save(e) } noValidate>

          <FormFields className={classes.formFields}>

            <SetProfileOptionsBilling
              value={this.state.data.billing}
              onChange={ (billing) => this._isMounted && this.setState({data: {...this.state.data, ...{billing}}}) }
            />

          </FormFields>

          <EditControllers sticky>
            <Button type="submit" onClick={ (e) => this.save(e) } color="primary" variant="contained" className={classes.submit}>Enregistrer</Button>
          </EditControllers>

        </Form>

      </Box>
    )
  }

}

const styles = theme => ({
  container: {
    paddingTop: theme.spacing(1),
  },
  submit: {
    width: '100%',
  },
  formFields: {
    padding: theme.spacing(0,2),
  },
});

EditProfileBilling.propTypes = {
  id_profile: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onSaved: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditProfileBilling);
